import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Marker, Polyline } from 'react-leaflet';
import L from 'leaflet';
import { addGlobalPopUpWrapper, clearGlobalPopUpWrapper } from '../actions';
import { POPUP_LIST_NAME } from '../../../configs';
import { infoFormatterIntl } from '../../../utils/formatters';
import { responseLogWithNotification } from '../../../utils/utils';
import { loadVisitsById } from '../../Visits/actions';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { AccordionDetails } from '../../../components/base/Accordion/AccordionDetails';
import LeafletMap from '../../../components/base/Map/LeafletMap';
import { FullScreenControl } from '../../../components/base/Map/FullScreenControl';
import { getVisitData } from '../../Visits/reducer';
import PointMarker from '../../../components/base/Map/PointMarker';
import {
  carIcon, finishPointIcon, intermediatePointIcon, passengerPointIcon, startPointIcon,
} from '../../../components/base/Map/icons/icons';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function VisitDetailsPopUp(props) {
  const {
    id,
  } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const {
    currentVisit = {},
    loadingCurrentVisit,
  } = useSelector(getVisitData);
  const [map, setMap] = useState(null);
  const [fullScreen, setFullScreen] = useState(false);

  const {
    vehicle = {},
  } = currentVisit;

  useEffect(() => {
    dispatch(loadVisitsById(id)).catch(responseLogWithNotification);
  }, [id]);

  const points = [];
  if (currentVisit?.trip_start_point?.length) {
    points.push(currentVisit?.trip_start_point);
  }
  if (currentVisit?.trip_intermediate_points?.length) {
    currentVisit?.trip_intermediate_points.forEach(point => {
      if (point?.length) {
        points.push(point);
      }
    });
  }
  if (currentVisit?.trip_end_point?.length) {
    points.push(currentVisit?.trip_end_point);
  }

  useEffect(() => {
    if (points?.length && map) {
      const bounds = L.latLngBounds(points);
      map.fitBounds(bounds, { padding: [20, 20] });
    }
  }, [JSON.stringify(points), map]);

  return (
    <div className={classNames('full-view custom-scroll-theme', { 'map-fullscreen': fullScreen })}>
      <TimerLoader loading={loadingCurrentVisit} />
      <div className="full-view-header">
        <div>{formatMessage({ id: 'driver.card.menu.history.details' })}</div>
        <Icons
          onClick={() => dispatch((clearGlobalPopUpWrapper({ key: POPUP_LIST_NAME.VISIT_DETAIL, id })))}
          customIcon
          icon="close"
        />
      </div>
      <div className="full-view-content">
        <Row className="row-cols-2">
          {infoFormatterIntl('visit.start_point_lat', currentVisit?.trip_start_point?.[0])}
          {infoFormatterIntl('visit.start_point_lon', currentVisit?.trip_start_point?.[1])}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('visit.end_point_lat', currentVisit?.trip_end_point?.[0])}
          {infoFormatterIntl('visit.end_point_lon', currentVisit?.trip_end_point?.[1])}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('trip_cost', currentVisit?.trip_cost)}
        </Row>
        <AccordionDetails
          content={(
            <>
              <Row className="row-cols-2">
                {infoFormatterIntl('vehicle_brand', vehicle?.vehicle_brand)}
                {infoFormatterIntl('vehicle_model', vehicle?.vehicle_model)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('vehicle_plate', vehicle?.vehicle_lpn)}
                {infoFormatterIntl('vin', vehicle?.vehicle_vin)}
              </Row>
            </>
                    )}
          toggleFunction={() => dispatch((addGlobalPopUpWrapper({
            window2: POPUP_LIST_NAME.TRANSPORT_DETAIL,
            id2: vehicle?.id,
          })))}
          title="Транспортное средство"
        />
        <AccordionDetails
          toggleFunction={() => dispatch((addGlobalPopUpWrapper({
            window2: POPUP_LIST_NAME.WAY_BILL_DETAIL,
            id,
          })))}
          title="Путевой лист"
        />
        {!loadingCurrentVisit
          ? (
            <div className="map-wrapper">
              <LeafletMap classNames="stops-map" setMap={setMap}>
                {/* {points && points.length > 0 ? points.map((trip, key) => { */}
                {/*  const lat = Number(trip[0]); */}
                {/*  const lon = Number(trip[1]); */}
                {/*  if (Number.isNaN(lat) || Number.isNaN(lon)) return null; */}
                {/*  const coords = [lat, lon]; */}
                {/*  return ( */}
                {/*    <PointMarker */}
                {/*      key={`circle-${key}`} */}
                {/*      center={coords} */}
                {/*    /> */}
                {/*  ); */}
                {/* }) : null} */}
                <FullScreenControl onClick={() => setFullScreen(!fullScreen)} fullScreen={fullScreen} />
                {points?.length && points[0]?.length && points[0][0] ? (
                  <Marker
                    position={[points[0][0], points[0][1]]}
                    icon={startPointIcon}
                  />
                ) : null}
                {points?.length > 2
                  ? points.map((point, i) => (
                    i && i !== (points.length - 1) ? (
                      <Marker
                        key={`marker-${i}`}
                        position={point}
                        icon={intermediatePointIcon}
                      />
                    ) : null
                  ))
                  : null}
                {points?.length && points[points.length - 1]?.length && points[points.length - 1][0] ? (
                  <Marker position={[points[points.length - 1][0], points[points.length - 1][1]]} icon={finishPointIcon} />
                ) : null}
                <Polyline
                  pathOptions={{ color: '#08A835', weight: 3 }}
                  positions={points}
                />
              </LeafletMap>
            </div>
          ) : null}
      </div>
    </div>
  );
}
